import { Injectable } from '@angular/core';
import {
  API_METHODS,
  API_URL,
  OperationType,
} from 'common/constants/sm-constants';
import { DataModel } from 'common/models/utility-models/base-model';
import { SystemService } from 'common/services/core-services/system.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { DataService } from '../base-data-services/data.service';
import { editInfo } from 'common/models/utility-models/utility-interface';
import { CapitalizePipe } from 'common/pipes/capitalize-pipe';

@Injectable()
export abstract class FormDataService<
  T extends DataModel
> extends DataService<T> {
  transformDataModel(apiRes: any, param: string) {
    throw new Error("Method not implemented.");
  }
  constructor(
    protected apiUrl: API_URL,
    protected http: SmApiService,
    protected ss: SystemService
  ) {
    super(ss, apiUrl, http);
  }

  abstract override getEditUrlAndMethod(id: any): editInfo;

  transformModel(model, metamodel: any = null): T {
    const tempModel = this.modifyModel(model, metamodel);
    const fileArray: any[] = [];
    let isformData: boolean = false;
    let finalModel: any;
    const formDataContains: any[] = [
      'singleimagepreview',
      'multipleimagepreview',
      'PDF',
      'VIDEO',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'ANY',
      'multitypeimagepreview',
    ];
    for (const key in tempModel) {
      if (
        key !== 'id' &&
        key !== 'createdAt' &&
        metamodel.properties[key] !== undefined
      ) {
        if (metamodel.properties[key]['isFormControl'] === false) {
          tempModel[key] = JSON.stringify(tempModel[key]);
        }
        if (formDataContains.includes(metamodel.properties[key]['proptype'])) {
          isformData = true;
        }
      }

      if (tempModel[key]?.type !== undefined) {
        const keyFeild = metamodel.properties[key]['propfileKey'];
        const val = tempModel[key];
        const obj = {
          key: keyFeild,
          value: val,
        };
        fileArray.push(obj);
        delete tempModel[key];
      }
    }
    const formData = new FormData();
    if (isformData) {
      fileArray.forEach((data: any) => {
        if (data.value) {
          formData.append(data.key, data.value);
        }
      });
      Object.keys(tempModel).forEach((key) => {
        formData.append(key, tempModel[key]);
      });
      // formData.append('data', JSON.stringify(tempModel));
      finalModel = formData;
    } else {
      finalModel = tempModel;
    }
    return finalModel;
  }



  getFormDataModel(model, propMeta) {
    const formData = new FormData();
    Object.keys(model)
      .filter(
        (element) =>
          element !== 'id' &&
          element !== 'createdOn' &&
          element !== 'createdBy' &&
          element !== 'modifiedOn' &&
          element !== 'modifiedBy' &&
          element !== 'activityBy' &&
          element !== 'activityOn' &&
          element !== 'uploadedOn' &&
          element !== 'uploadedBy'
      )
      .forEach((a) => {
        if (propMeta.properties[a]['fieldType'] === 'file') {
          formData.append(
            propMeta.properties[a]['propfileKey'].toString(),
            model[a]
          );
          model[a] = '';
        }
      });
    formData.append('data', JSON.stringify(model));

    return formData;
  }

  //   override async getDataById(data): Promise<any> {
  //     return await new Promise((resolve, reject) => {
  //       this.getUpdateData(data)
  //         .then((res) => {
  //           resolve(res);
  //         })
  //         .catch((e) => reject(e));
  //     });
  //     }




  // Gaurav ADDDED
  override modifyModel(model, metamodel = null) {
    return model;
  }

  beforeGetData(model: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      resolve(model);
    });
  }

  afterGetData(model: T): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      resolve(model);
    });
  }

  transformUIModel(data: any): T {
    return data;
  }

  override async getData(data): Promise<any> {
    return await new Promise((resolve, reject) => {
      Promise.resolve()
        .then(() => {
          return this.beforeGetData(data);
        })
        .then((returnModel) => {          
          return this.getDataById(returnModel);
        })
        .then((returnModel) => {
          return this.transformUIModel(returnModel);
        })
        .then((result: any) => {
          resolve(this.afterGetData(result));
        })
        .catch((err) => {
          reject(err);
        });

    })
  }






  async submitModel(model, metamodel, dataModel): Promise<any> {

    return await new Promise<T>((resolve, reject) => {
      Promise.resolve()
        .then(() => {
          return this.beforePostData(model, metamodel, dataModel);
        })
        .then((returnModel) => {
          return this.postData(returnModel, this.getPostDataType());
        })
        .then((result) => {
          if (result.status === 'Success') {
            if (result.details !== 'Term Flag updated') {
              this.systemService.showSuccess(result.msg);
            }
            return this.afterPostData(model, result);
          } else {
            this.systemService.showError(result.error);
            return null;
          }
        })
        .then((finalresult) => {
          resolve(finalresult);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  beforePostData(model: T, metamodel: any, dataModel: any): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      resolve(this.modifyPostModel(this.transformModel(model, metamodel), dataModel));
    });
  }

  afterPostData(model: T, result: any = null): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      resolve(this.transformAPIData(model));
    });
  }

  modifyPostModel(formModel, dataModel) {
    return formModel;
  }

  transformAPIData(data: any) {
    return data;
  }

  convertDateToStringWithoutConversion(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    return (
      `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day
      }` +
      `T${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes
      }:${seconds < 10 ? '0' + seconds : seconds}`
    );
  }

  getDataFromAPIformUrl(url: string): Promise<any> {
    return new Promise((res, rej) => {
      this.getData(url)
        .then((data) => {
          res(data);
        })
        .catch((err) => {
          rej(err);
        });
    });
  }

  getPostDataType() {
    return true;
  }
}
